<template>
	<div>
		<notifications></notifications>
		<div :class="{'nav-open': $sidebar.showSidebar}">
			<router-view v-if="$store.state.authentication.loggedIn"></router-view>
			<login v-if="!$store.state.authentication.loggedIn"></login>
		</div>
	</div>
</template>

<script>
	import Login from '@/pages/Login.vue'
	export default {
		components: {
			Login
		},
		data() {
			return {
				default: null
			}
		},
		created() {
			console.log()
		}
	}
</script>
<style>
	.verify {
		color:#0766FF !important;
		font-size: 18px !important
	}
	.md-textarea {
		min-height: 400px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
	}

	.el-tabs__item.is-active {
		color: #2A5E83 !important;
	}

	.el-tabs__item:hover {
		color: #2A5E83 !important;
	}

	.el-tabs__active-bar {
		background-color: #2A5E83 !important;
	}

	.md-progress-bar-fill {
		background-color: #2A5E83 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.green {
		background-color: #55efc4;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.neutral {
		background-color: #DDD;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.late {
		background-color: #fab1a0;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.error {
		background-color: #f35734;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.warn {
		background-color: #f39c12;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.return {
		background-color: #fd79a8;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.md-list-item-text {
		font-family: "Nunito", "Hanuman" !important;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue